import { Component } from '@angular/core';
import { ChallengeComponent } from '../../shared/components/challenge/challenge.component';
import { ProblemService } from '../../services/problem.service';
import { DomainProblems } from '../../shared/models/domain-problems/DomainProblems';
import { DomainProblemsDto } from '../../shared/models/domain-problems/DomainProblemsDto';
import { ImageAssets } from '../../constants/ImageAssets';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [ChallengeComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  mathProblem: DomainProblems;
  playAndEarnImage = ImageAssets.PLAY_AND_EARN;
  
  constructor(private problemService: ProblemService) {
    this.generateNewQuestion();
  }

  generateNewQuestion(): void {
    this.problemService.generateMathProblem().subscribe({
      next: (mathProblemDto: DomainProblemsDto) => {
        this.mathProblem = new DomainProblems(mathProblemDto);
      }
    });
  }

  onGenerateNewQuestion = () => this.generateNewQuestion();
}
